import { StarSolidIcon } from '@mentimeter/ragnar-visuals';
import React from 'react';
import { type ButtonT, Button } from '@mentimeter/ragnar-ui/button';
import { useTranslations } from 'next-intl';

export type UpgradeButtonDataHandler = ButtonT & {
  isEducational: boolean;
  text?: string;
};

export function UpgradeButton({
  isEducational,
  text,
  ...buttonProps
}: UpgradeButtonDataHandler) {
  const t = useTranslations('purchasing.paywalls');

  return (
    <Button
      href={isEducational ? '/plans/education' : '/plans'}
      variant="positive"
      target="_blank"
      iconLeading={StarSolidIcon}
      {...buttonProps}
    >
      {text ?? t('upgrade_button')}
    </Button>
  );
}
